module.exports = __webpack_public_path__ + "static/media/material-icons.f44512c0.woff2";